import { render, staticRenderFns } from "./DialogProfileAccountDetail.vue?vue&type=template&id=579a3dc1&"
import script from "./DialogProfileAccountDetail.vue?vue&type=script&lang=js&"
export * from "./DialogProfileAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports